
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23h-10v-3.8a2.5 2.5 0 002-2.45v-4a2.5 2.5 0 00-2-2.45V6a.5.5 0 00-1 0v4.3a2.5 2.5 0 00-2 2.45v4c0 1.2.86 2.22 2 2.45V23H1V.5a.5.5 0 00-1 0v23c0 .28.22.5.5.5h23a.5.5 0 000-1zm-12-6.25v-4a1.5 1.5 0 013 0v4a1.5 1.5 0 01-3 0z"}}),_c('path',{attrs:{"d":"M6 14.2V19a.5.5 0 001 0v-4.8a2.5 2.5 0 002-2.45v-4A2.5 2.5 0 007 5.3V.5a.5.5 0 00-1 0v4.8a2.5 2.5 0 00-2 2.45v4c0 1.2.86 2.22 2 2.45zM5 7.75c0-.81.65-1.47 1.46-1.5l.04.01h.04c.8.02 1.46.68 1.46 1.49v4a1.5 1.5 0 01-3 0v-4zm14 6.45V19a.5.5 0 001 0v-4.8a2.5 2.5 0 002-2.45v-4a2.5 2.5 0 00-2-2.45V.5a.5.5 0 00-1 0v4.8a2.5 2.5 0 00-2 2.45v4c0 1.2.86 2.22 2 2.45zm-1-6.45c0-.81.65-1.47 1.46-1.5l.04.01h.04c.8.02 1.46.68 1.46 1.49v4a1.5 1.5 0 01-3 0v-4z"}})])
          )
        }
      }
    